<template>
  <div class="lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="DeleteUser-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="DeleteUser-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
      <WrapperSvgTitleText>
        <template v-slot:svg>
          <svg viewBox="0 0 113.39 113.39">
            <g transform="translate(175.085 -251.936)">
              <path class="DeleteUser-st0" d="M-154.39,251.94h72c11.43,0,20.69,9.26,20.69,20.69v72c0,11.43-9.26,20.69-20.69,20.69h-72c-11.43,0-20.69-9.26-20.69-20.69v-72C-175.09,261.2-165.82,251.94-154.39,251.94z"/>
              <path class="DeleteUser-st1" d="M-77.48,353.99c0,0-15.68,2.86-40.91,2.86s-40.91-2.86-40.91-2.86c-2.46,0-4.45-1.99-4.45-4.45c0,0-2.86-15.68-2.86-40.91s2.86-40.91,2.86-40.91c0-2.46,1.99-4.45,4.45-4.45h0c0,0,15.68-2.86,40.91-2.86s40.91,2.86,40.91,2.86c2.46,0,4.45,1.99,4.45,4.45l0,0c0,0,2.86,15.68,2.86,40.91s-2.86,40.91-2.86,40.91C-73.03,352-75.02,353.99-77.48,353.99C-77.48,353.99-77.48,353.99-77.48,353.99z"/>
            </g>
            <path class="DeleteUser-st2" d="M67.79,33.16h13.35c3.05,0,5.53,2.47,5.53,5.53V54.8c0,3.05-2.47,5.53-5.53,5.53H67.79c-3.05,0-5.53-2.47-5.53-5.53V38.68C62.26,35.63,64.73,33.16,67.79,33.16z"/>
            <path class="DeleteUser-st3" d="M32.33,33.16h13.35c3.05,0,5.53,2.47,5.53,5.53V54.8c0,3.05-2.47,5.53-5.53,5.53H32.33c-3.05,0-5.53-2.47-5.53-5.53V38.68C26.8,35.63,29.28,33.16,32.33,33.16z"/>
          </svg>
        </template>
        <template v-slot:title>
          {{$store.getters.language.texts.DeleteUser_title}}
        </template>
        <template v-slot:text>
          {{$store.getters.language.texts.DeleteUser_text}}
        </template>
      </WrapperSvgTitleText>
    </div>
    <div class="DeleteUser-button lxn-margin-auto lxn-w100">
      <CustomButton :disabled="isHubOffline" @click="DeleteUser" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        {{$store.getters.language.texts.DeleteUser_button}}
      </CustomButton>
    </div>
    <div class="DeleteUser-button lxn-margin-auto lxn-w100">
      <CustomButton @click="next2" bgColor="#F36C4F" iconRight="arrowRight" iconRightColor="#F36C4F" iconRightBgColor="#D5E6F0" :iconRightPadding="8" :useLanguageDirection="true" textColor="#FFFFFF">
        {{$store.getters.language.texts.DeleteUser_button2}}
      </CustomButton>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import WrapperSvgTitleText from '@/components/addNewDevice/WrapperSvgTitleText.vue'
import CustomButton from '@/components/CustomButton.vue'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'

export default {
  name: 'DeleteUser',
  components: {
    CustomCurve,
    TopNav,
    WrapperSvgTitleText,
    CustomButton
  },
  computed: {
    hub: function () {
      return this.$store.getters.getHubByUUID(this.$route.params.hubUUID);
    },
    userUUID: function () {
      return this.hub.users[this.$route.params.userIndex].uuid;
    },
    isHubOffline: function () {
      if(this.hub.connectionStatus.local == 2 || this.hub.connectionStatus.online == 2){
        return false;
      }else{
        return true;
      }
    },
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    DeleteUser: function () {
      this.$store.commit('setAppBusy', true);
      var uuids = [];
      for(var i = 0; i < this.hub.users.length; i++){
        if(!this.hub.users[i].isOwner && this.hub.users[i].uuid != this.userUUID){
          uuids.push(this.hub.users[i].uuid);
        }
      }
      this.$store.dispatch('grantSnapshotAccess', {
        userUUID: this.$store.state.user.uuid,
        token: this.$store.state.user.loginToken,
        hubUUID: this.hub.uuid,
        uuids: uuids,
      })
      .then( response => {
        if(response.data.status == 'success'){
          var messagingHook = new Messaging(new Logger(false));
          messagingHook.init({
            psk: this.hub.psk,
            destinationUUID: this.hub.uuid,
            sourceUUID: this.$store.state.user.uuid
          });
          this.$store.dispatch('deleteUserFromHub', {
            messagingHook: messagingHook,
            hubUUID: this.hub.uuid,
            bodyContent: {
              targetUserUUID: this.userUUID,
            }
          })
          .then( () => {
            this.$store.commit('deleteUser', {hubIndex: this.hub.index, userIndex: this.$route.params.userIndex});
            this.$store.commit('saveState');
            this.$store.dispatch('saveDatabase', this.hub.uuid)
            .finally( () => {
              this.$router.push('/hubUserSettings/' + this.$route.params.hubUUID);
              this.$store.commit('setAppBusy', false);
            })
          })
          .catch( response => {
            if(response.rejectCode == 1){
              this.$store.commit('deleteUser', {hubIndex: this.hub.index, userIndex: this.$route.params.userIndex});
              this.$store.commit('saveState');
              this.$router.push('/hubUserSettings/' + this.$route.params.hubUUID);
            }else if(response.rejectCode == 2){
              this.$store.commit('setHubStatus', {
                hubIndex: response.hubIndex,
                connectionStatus: {
                  local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                },
              });
              this.$router.push('/SettingsHubError');
            }else{
              this.$router.push('/SettingsHubError');
            }
            this.$store.commit('setAppBusy', false);
          });
        }else{
          alert(this.$store.getters.language.texts.DeleteUser_serverError);
          this.$store.commit('setAppBusy', false);
        }
      })
      .catch( () => {
        alert(this.$store.getters.language.texts.Common_internetError);
        this.$store.commit('setAppBusy', false);
      });
    },
    next2: function () {
      this.$router.go(-1);
    }
  }
}
</script>

<style>
  .DeleteUser-topCurve-wrapper {
    height: 200px;
  }
  .DeleteUser-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 1;
    background-color: #ffffff;
  }
  .DeleteUser-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
	.DeleteUser-st0 {
    fill: #ECECEC;
  }
	.DeleteUser-st1 {
    fill: #53636C;
  }
	.DeleteUser-st2 {
    fill: #1EA5DE;
  }
	.DeleteUser-st3 {
    fill: #F36C4F;
  }
</style>
